import React from 'react';
import { useHistory } from "react-router-dom";
import {
    Paper,
    Box,
    Typography,
    makeStyles,
    Grid,
} from '@material-ui/core';
import KenInput from '../../../components/KenInputField';
import KenSelect from '../../../components/KenSelect';
import { withRouter } from 'react-router-dom';
import KenButton from '../../../components/KenButton';
//import { otpGenerator } from '../../../utils/Otp';
import clsx from 'clsx';
import { withFormik } from 'formik';
//import { createContact } from '../../../utils/ApiService';
import * as Yup from 'yup';
import '../../../themes/styles.scss'


const useStyles = makeStyles((theme) => ({

    paper: {
        // width: 450,
        // padding: theme.spacing(2, 4, 3),
        // outline: 'none',
        // [theme.breakpoints.only('xs')]: {
        // width: "90%",
        // }
    },
    hide: {
        display: 'none',
    },
    reSend: {
        cursor: "pointer",
        float: "right",
    },
    Heading: {
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: theme.palette.KenColors.neutral100,
        textAlign: "left",
        textTransform: "uppercase",
        marginBottom: 24,
    },
    change: {
        cursor: 'pointer',
    },
    registerLabel: {
        textAlign: "start",
        marginBottom: "10px",
        color: theme.palette.KenColors.black,
        textTransform: "capitalize",
        fontWeight: "600",
        fontSize: 14
    },
    applyselfLabel: {
        fontSize: "14px !important"
    }

}))

export default withRouter(function SignInInfo(props) {
    //console.log('[SignInInfo] props', props);
    return (
        <div>
            <FormikHoc {...props} />
        </div>
    )
})


const SignInForm = (props) => {
    //console.log("props in siginForm", props);
    const {
        values,
        //toggle,
        //programID,
        options,
        //notify,
       // handleClose,
        handleSnackbarOpen,
        //programName,
        //instituteId,
        //setFieldValue,
        setFieldTouched,
        touched,
        errors,
        handleChange,
        handleSubmit,
        //currentRow
    } = props;

    const classes = useStyles();
    const [otp, setOtp] = React.useState();
    //const [showOtpEnter, setShowOtpEnter] = React.useState(false);
    //const [submitted, setSubmitted] = React.useState(false);
    //console.log("current row in signin", currentRow);

    const change = (name, e, index) => {
        e.persist();
        handleChange(e);
        setFieldTouched(name, true, false);
    };

    React.useEffect(() => {
        if (otp) {
            alert(`Please note down the OTP for further process. The OTP is ${otp}`);
        }
    }, [otp])

    // const handleOtp = () => {
    //     if (values.phone.length === 10) {
    //         setShowOtpEnter(true);
    //         setOtp(otpGenerator())
    //     } else {
    //         //console.log("phone", values.phone);
    //         handleSnackbarOpen('error', 'Invalid Mobile/Phone Number Should Have 10 Numbers');
    //     }
    // }

    // const handleWithoutOtp = () => {
    //     //alert('Regenerate OTP and try again.');
    //     handleSnackbarOpen('error', 'Invalid OTP. Please try again.');
    // }

    // const handleModalClose = () => {
    //     handleClose(!submitted);
    //     handleSnackbarOpen('success', 'This is a custom success message..!!');
    // }
    // const gender = [
    //     {
    //         label: 'Male',
    //         value: 'Male'
    //     },
    //     {
    //         label: 'Female',
    //         value: 'Female'
    //     },
    //     {
    //         label: 'Other',
    //         value: 'Other'
    //     },
    // ];

    // const relations = [
    //     {
    //         label: 'Father',
    //         value: 'father'
    //     }, {
    //         label: 'Mother',
    //         value: 'mother'
    //     }, {
    //         label: 'Guardian',
    //         value: 'guardian'
    //     },];

    return (
        <form>
            <Paper className={classes.paper} elevation={0}>
                <Box textAlign="center">
                    <Box pt={1}>
                        <Typography variant="body2" className={classes.registerLabel}>Notify Me</Typography>
                    </Box>
                    <Box pt={1}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={3} md={6}>
                                <KenInput
                                    required
                                    label="First Name"
                                    name="firstName"
                                    value={values.firstName}
                                    onChange={change.bind(null, "firstName")}
                                    errors={errors.firstName}
                                    touched={touched.firstName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={9} md={6}>
                                <KenInput
                                    required
                                    label="Last Name"
                                    name="lastName"
                                    value={values.lastName}
                                    onChange={change.bind(null, "lastName")}
                                    errors={errors.lastName}
                                    touched={touched.lastName}
                                />
                            </Grid>
                        </Grid>

                    </Box>
                    <Box pt={1}>
                        <KenInput
                            required
                            label="Email Address"
                            name="email"
                            value={values.email}
                            onChange={change.bind(null, "email")}
                            errors={errors.email}
                            touched={touched.email}
                        />
                    </Box>

                    <Box pt={1}>
                        <div className={clsx({ [classes.hide]: !values.applyingForSelf })}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <KenInput
                                        required
                                        label="Phone Number"
                                        name="phone"
                                        value={values.phone}
                                        onChange={change.bind(null, "phone")}
                                        errors={errors.phone}
                                        touched={touched.phone}
                                        startAdornment
                                        startAdornmentIcon={
                                            <div style={{ marginTop: '-2px', marginBottom: "-4px" }}>
                                                <KenSelect
                                                    required
                                                    options={options}
                                                    value={options[0]}
                                                />
                                            </div>
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Box>
                    
                    <Box pt={1} display="flex" justifyContent="flex-end">
                        <KenButton
                            variant="primary"
                            //onClick={handleModalClose}
                            onClick={handleSubmit}
                        >
                            Submit
                       </KenButton>
                    </Box>

                </Box>
                
            </Paper >
        </form>
    )
}


const FormikHoc = props => {

    const history = useHistory();
    //console.log('props of signIN modal',props);
    const { instituteId, programID, programName, handleSnackbarOpen, currentRow } = props;
    //console.log("currentRow in formik signin", currentRow );

    const SignInFormik = withFormik({
        mapPropsToValues: () => ({
            email: '',
            phone: '',
            firstName: '',
            lastName: '',
            applyingForSelf: true
        }),

        validationSchema: Yup.object({
            firstName: Yup.string()
                .max(15, 'Must be 15 characters or less')
                .required('Required'),
            lastName: Yup.string()
                .max(20, 'Must be 20 characters or less')
                .required('Required'),
            phone: Yup.number().required().test('len', 'Invalid Mobile Number', (val) => {
                if (val) {
                    //console.log("val", val);
                    return val.toString().length === 10;
                }
            }),
            email: Yup.string().email("Must be a valid email address") .required('Required'),
        }),



        handleSubmit: (values) => {
            //console.log("from notify",values);
            handleSnackbarOpen('error', `Notify functionality comming soon`);
            //handleSnackbarOpen('error', 'Notify me done');
        },

        displayName: 'SignInInformation',
    })(SignInForm);

    return <SignInFormik {...props} />
};
